import { useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/index';


import { videoLikeDislikeApiCall, markSeriesVideoWatchApiCall } from "@/services/api"
import { toast } from "sonner";
import {
    toggleLikeVideoById,
    toggleDislikeVideoById,
    setVideoWatchedById,
} from "@/store/slices/video/seriesSlice"
import { setVideoWatchedFlag } from "@/store/slices/video/videoSlice"
import ShareModal from '@/components/video/videoShareModal/videoShareModal'
import ReportModal from '@/components/video/reportModal/reportModal'

import VideoDisView from "./view";

function findVideoInSeries(
    series: { videos?: { _id: string; isWatched?: boolean }[] }[],
    videoDocId: string
) {
    if (!Array.isArray(series)) return undefined;
    for (const section of series) {
        const v = section.videos?.find((x) => x._id === videoDocId);
        if (v) return v;
    }
    return undefined;
}

export default function VideoDis(props: any) {
    const dispatch = useDispatch()
    const series = useSelector((state: RootState) => state.seriesReducer.series);
    const storeVideo = useSelector((state: RootState) => state.videoReducer.video);

    const videoDetailsForView = useMemo(() => {
        const base = props.currentVideoObj;
        if (!base || !base._id) return base;
        const fromSeries = findVideoInSeries(series, base._id);
        const seriesWatched = fromSeries?.isWatched;
        const reduxWatched =
            storeVideo && storeVideo._id === base._id ? storeVideo.isWatched : undefined;
        const isWatched =
            typeof seriesWatched === 'boolean'
                ? seriesWatched
                : typeof reduxWatched === 'boolean'
                  ? reduxWatched
                  : base.isWatched;
        if (Boolean(isWatched) === Boolean(base.isWatched)) return base;
        return { ...base, isWatched: Boolean(isWatched) };
    }, [props.currentVideoObj, series, storeVideo]);
    const [showShareUrlModal, setShowShareUrlModal] = useState(false);
    const [showReportModal, setShowReportModal] = useState(false);
    const [urlToShare, setUrlToShare] = useState("")
    // const seriesDetails = useSelector((state: RootState) => state.seriesReducer.series);
    // const videoDetails = useSelector((state: RootState) => state.videoReducer.video);
    const [likeDislikeBtnLoading, setLikeDislikeBtnLoading] = useState(false)


    const handleLike = async () => {
        setLikeDislikeBtnLoading(true)
        if (props.currentVideoObj) {
            const videoDocId = props.currentVideoObj._id
            const payload = {
                videoDocId: videoDocId,
                action: "like",
                isWelcomeSeries: props.isWelcomeSeries
            }
            const likeDislikeApiCallStatus = await videoLikeDislikeApiCall(payload)
            if (likeDislikeApiCallStatus.status) {
                dispatch(toggleLikeVideoById(payload));
                // console.log(likeDislikeApiCallStatus)
            } else {
                console.log("Issue in handleLike")
            }
        }
        setLikeDislikeBtnLoading(false)
    }


    const handleDislike = async () => {
        setLikeDislikeBtnLoading(true)
        if (props.currentVideoObj) {
            const videoDocId = props.currentVideoObj._id
            const payload = {
                videoDocId: videoDocId,
                action: "dislike",
                isWelcomeSeries: props.isWelcomeSeries
            }
            const likeDislikeApiCallStatus = await videoLikeDislikeApiCall(payload)
            if (likeDislikeApiCallStatus.status) {
                dispatch(toggleDislikeVideoById(payload));
                // console.log(likeDislikeApiCallStatus)
            } else {
                console.log("Issue in handleLike")
            }
        }
        setLikeDislikeBtnLoading(false)
    }

    const handleShare = () => {
        const currentUrl = window.location.href;
        setUrlToShare(currentUrl)
        handleOpenShareUrlModal()
    }
    const handleOpenShareUrlModal = () => {
        setShowShareUrlModal(true)
    };
    const handleCloseShareUrlModal = (status: string) => {
        setShowShareUrlModal(false)
    }


    const handleReport = () => {
        handleOpenShowReportModal()
    }
    const handleOpenShowReportModal = () => {
        setShowReportModal(true)
    };
    const handleCloseShowReportModal = (status: string) => {
        setShowReportModal(false)
    }

    const handleWatchStatusChange = async (isWatched: boolean): Promise<boolean> => {
        if (!props.currentVideoObj?._id) return false;
        const videoDocId = props.currentVideoObj._id;

        if (props.seriesId) {
            const res = await markSeriesVideoWatchApiCall({
                seriesId: props.seriesId,
                videoDocId,
                isWelcomeSeries: Boolean(props.isWelcomeSeries),
                isPGCourseSeries: Boolean(props.isPGCourseSeries),
                isSubscribedSeries: Boolean(props.isSubscribedSeries),
                isWatched,
            });
            if (!res.status) {
                toast.error(
                    typeof res.message === "string" && res.message.trim()
                        ? res.message
                        : "Could not update watch status"
                );
                return false;
            }
        }

        dispatch(setVideoWatchedById({ videoDocId, isWatched }));
        dispatch(setVideoWatchedFlag(isWatched));
        return true;
    };

    return (
        <>
            <VideoDisView
                videoDetails={videoDetailsForView}
                seriesNotes={props.seriesNotes}
                handleLike={handleLike}
                handleDislike={handleDislike}
                handleShare={handleShare}
                handleReport={handleReport}
                handleWatchStatusChange={handleWatchStatusChange}
                likeDislikeBtnLoading={likeDislikeBtnLoading}
                isLoading={props.isLoading}
            />

            <ShareModal
                show={showShareUrlModal}
                handleClose={handleCloseShareUrlModal}
                urlToShare={urlToShare}
            />

            <ReportModal
                show={showReportModal}
                handleClose={handleCloseShowReportModal}
                videoDetails={props.currentVideoObj}
            />


        </>
    );
}

